// extracted by mini-css-extract-plugin
module.exports = {"last-comment-info":"last-comment-info___3wdo5"};